import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface CountdownTimerProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
}
export function CountdownTimer({
  initialHours = 1,
  initialMinutes = 26,
  initialSeconds = 42
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const totalSeconds = initialHours * 3600 + initialMinutes * 60 + initialSeconds;
    let currentSeconds = totalSeconds;
    const timer = setInterval(() => {
      currentSeconds--;
      if (currentSeconds < 0) {
        currentSeconds = totalSeconds; // Reset
      }
      setTimeLeft({
        hours: Math.floor(currentSeconds / 3600),
        minutes: Math.floor(currentSeconds % 3600 / 60),
        seconds: currentSeconds % 60
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [initialHours, initialMinutes, initialSeconds]);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-234" data-mp="3vpd40ynr2ywt">
      <div className="bg-navy-900 border border-navy-700/50 rounded-lg p-3 md:p-4 min-w-[70px] md:min-w-[90px] flex justify-center items-center shadow-inner relative overflow-hidden" data-id="element-235" data-mp="3vq5zh3h9e1zn">
        <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" data-id="element-236" data-mp="9h4rcwyujv0w" />
        <AnimatePresence mode="popLayout" data-id="element-237" data-mp="4iaaw1ocqijy">
          <motion.span key={value} initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: -20,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="font-anton text-3xl md:text-5xl text-gold-500 tracking-wider" data-id="element-238" data-mp="4h8x3pfybhyj">
            {formatNumber(value)}
          </motion.span>
        </AnimatePresence>
      </div>
      <span className="text-xs md:text-sm font-oswald uppercase tracking-widest text-gray-400 mt-2" data-id="element-239" data-mp="3l3xtzgng4tlz">
        {label}
      </span>
    </div>;
  return <div className="flex items-center justify-center gap-2 md:gap-4" data-id="element-240" data-mp="3uso2lbczrfty">
      <TimeUnit value={timeLeft.hours} label="Heures" data-id="element-241" data-mp="3uv0v2igdl8l9" />
      <span className="text-2xl md:text-4xl font-anton text-navy-700 pb-6" data-id="element-242" data-mp="3llb0it8r7j7">
        :
      </span>
      <TimeUnit value={timeLeft.minutes} label="Minutes" data-id="element-243" data-mp="8kogu5h1phs8" />
      <span className="text-2xl md:text-4xl font-anton text-navy-700 pb-6" data-id="element-244" data-mp="cnbe4lwhjuwt">
        :
      </span>
      <TimeUnit value={timeLeft.seconds} label="Secondes" data-id="element-245" data-mp="hmfld6zuniki" />
    </div>;
}